import { useGetBudgetReference, useGetBudgetSlp } from '../../../../hooks/budgets';

import MeterForecastWizardStep1 from './MeterForecastWizardStep1';
import MeterForecastWizardStep2 from './MeterForecastWizardStep2';
import { SdpResponse } from '../../../../models/SdpResponse';
import Skeleton from 'react-loading-skeleton';
import { Wizard } from 'react-use-wizard';
import { uiState } from '../../../../atoms/uiAtom';
import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';

export interface MeterForecastWizardProps {
  sdp?: SdpResponse | null;
}
export default function MeterForecastWizard({ sdp }: MeterForecastWizardProps) {
  const setUiState = useSetRecoilState(uiState);

  const {
    isFetching: isFetchingBudgetReference,
    isError: IsErrorBudgetReference,
    data: budgetReference,
  } = useGetBudgetReference(sdp?.id);
  const {
    isFetching: isFetchingBudgetSlp,
    isError: IsErrorBudgetSlp,
    data: budgetSlp,
  } = useGetBudgetSlp(sdp?.id, sdp?.tariffChoice);

  useEffect(() => {
    setUiState((state) => ({
      ...state,
      hasError: IsErrorBudgetReference,
    }));
  }, [IsErrorBudgetReference, IsErrorBudgetSlp, setUiState]);

  const wizardSkeletonRenderer = (
    <div className="text-center">
      <Skeleton count={1} height={16} width="40%" className="mb-2" />
      <Skeleton count={1} height={16} width="80%" className="mb-4" />
      <Skeleton count={1} height={80} width="80%" className="mb-2" />
      <Skeleton count={1} height={16} width="70%" className="mb-4" />
      <Skeleton count={1} height={16} width="50%" className="mb-6" />
    </div>
  );

  return (
    <div className="meter-forecast__wizard">
      {isFetchingBudgetSlp ||
      isFetchingBudgetReference ||
      IsErrorBudgetSlp ||
      IsErrorBudgetReference ? (
        wizardSkeletonRenderer
      ) : (
        <div className="widget meter-forecast__wizard__widget">
          <Wizard>
            <MeterForecastWizardStep1 budgetReference={budgetReference?.data} />
            <MeterForecastWizardStep2 budgetSlp={budgetSlp?.data} sdpId={sdp?.id} />
          </Wizard>
        </div>
      )}
    </div>
  );
}
